import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
} from '@angular/core';
import { AccordionComponent } from '@domgen/dgx-fe-components/accordion';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { TranslatePipe } from '@domgen/dgx-fe-i18n';
import {
  ProtectionBenefitsAccordionPanel,
  REGISTRATION_CONFIG,
  RegistrationConfig,
} from '@us-registration/util-models';

@Component({
  selector: 'us-registration-protection-benefits-accordion-wib',
  templateUrl: './protection-benefits-accordion-wib.component.html',
  styleUrls: ['./protection-benefits-accordion-wib.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AccordionComponent,
    IconComponent,
    NgClass,
    RichTextComponent,
    TranslatePipe,
    NgIf,
  ],
})
export class ProtectionBenefitsAccordionWibComponent {
  @Input() isDesktop?: boolean;

  constructor(
    @Inject(REGISTRATION_CONFIG)
    private readonly registrationConfig: RegistrationConfig
  ) {}

  warrantyLength = this.registrationConfig.warrantyLengthInYears;

  @Input() panels: ProtectionBenefitsAccordionPanel[] = [];
}
